'use client';

import { useGetOrganization } from '@/config/sales/organization/client';
import { useSession } from '@/providers/session-provider';
import { BASE_BACKEND_URL } from '@/requests/constants';
import Intercom from '@intercom/messenger-js-sdk';
import type { Organization } from '@pigello/pigello-matrix';
import { DateTime } from 'luxon';

function IntercomInit({ organization }: { organization: Organization }) {
  const {
    data: {
      session: { customerId, userId },
      user,
    },
  } = useSession();

  Intercom({
    app_id: 'ilbv7ji4',
    region: 'eu',
    user_id: userId,
    name: user.communicationName,
    username: user.username,
    email_verified: user.emailVerified,
    phone_verified: user.phoneNumberVerified,
    detail_access: user.detailAccess,
    email: user.email,
    created_at: DateTime.fromISO(user.createdAt).toUnixInteger(),
    company: {
      company_id: customerId,
      name: organization.name,
    },
    phone: user?.phoneNumber,
    avatar: {
      type: 'avatar',
      image_url: user?.profilePicture?.get,
    },
    hide_default_launcher: true,
  });

  return <></>;
}

const INTERCOM_DEMO_CUSTOMER_IDS = [
  '72583069-f587-4cbe-8004-a16d7f77b76b',
  'eae8814b-3282-49b5-b9e5-c40e495825e6',
];
export const getIsTrustedCustomer = (customer_id: string | undefined) =>
  !!customer_id && INTERCOM_DEMO_CUSTOMER_IDS.includes(customer_id);

export default function IntercomWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    data: {
      session: { organizationId },
    },
  } = useSession();
  const {
    data: {
      session: { customerId },
    },
  } = useSession();
  const isTrustedCustomer = getIsTrustedCustomer(customerId);

  const { data: mainOrg } = useGetOrganization({
    id: organizationId,
    enabled: !!self,
  });

  const isDev = BASE_BACKEND_URL?.includes('dev.api');

  return (
    <>
      {mainOrg && (!isDev || isTrustedCustomer) && (
        <IntercomInit organization={mainOrg}></IntercomInit>
      )}
      {children}
    </>
  );
}
